import React, { useState, useCallback } from "react";
import {
  BiRightArrowAlt,
  BiSolidArrowToRight,
  BiSolidXCircle,
  BiXCircle,
} from "react-icons/bi";
import { BsArrow90DegRight, BsArrowRight } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { applyCustomFontStyles, renderCommentsCountTextFormat, THEME_SETTING } from "../data";
import debounce from "lodash.debounce";
import QuizTextEditor from "../../../components/QuizTextEditor/QuizTextEditor";
import StarRatings from "react-star-ratings";
import { Button } from "reactstrap";
import Toggle from "react-toggle";
import TriviaCommentsComponent from "./TriviaCommentsComponent";
import { FaRegComment } from "react-icons/fa6";
import { hexToRgb } from "../../../utils/constants";

export default function TriviaRatingComponent({
  view,
  themeSettings,
  callApiToAutoSave,
  isEditable,
  showRatingUI,
  editRatingData,
  ratingData,
  triviaId,
  ratingComments,
  updateTriviaComments,
}) {
  const isMobile = view === "MOBILE";

  const [commentsPopoverOpen, setCommentsPopoverOpen] = useState(false);

  const [starRating, setStarRating] = useState(0);

  const editRatingText = value => {
    const data = {
      ...ratingData,
    };

    data["heading"] = value;

    editRatingData(data);
    debounceAutoSaveData("ratingPage", data);
  };

  const setComments = comments => {
    const data = {
      ...ratingData,
      commentsCount: comments.length,
    };

    updateTriviaComments("RATING", comments);

    editRatingData(data);
    callApiToAutoSave("ratingPage", data);
  };
  const editRatingIsRequired = value => {
    const data = {
      ...ratingData,
    };

    data["isRequired"] = value;

    editRatingData(data);
    debounceAutoSaveData("ratingPage", data);
  };

  const debounceAutoSaveData = useCallback(
    debounce(callApiToAutoSave, 3000),
    []
  );
  return (
    <div
      className={
        isMobile
          ? "trivia-survey-edit-questions-ui-mobile py-1 px-3 endUi"
          : "trivia-survey-edit-questions-ui py-1 endUi "
      }
      style={{
        backgroundColor: themeSettings.quizBackgroundColor,
        color: themeSettings.quizTextColor,
        position: "relative",
      }}
    >
      <div  style={applyCustomFontStyles(themeSettings)}>
      <div className="my-5 text-center">
        <div
          className="my-5 d-flex justify-content-center"
          style={{ fontSize: "40px" }}
        >
          <QuizTextEditor
            blockId={2}
            value={ratingData.heading}
            onChange={e => {
              editRatingText(e);
            }}
            placeholder="Rating title..."
            style={{
              width: "100%",
              textAlign: "center",
            }}
            disabled={!isEditable}
            questionThemeSettings={themeSettings}
          />
        </div>

        {console.log("hhhhhhh",ratingData.starColor)}

        <StarRatings
          rating={starRating || 0}
          starRatedColor={ratingData.starColor}
          changeRating={setStarRating}
          numberOfStars={5}
          name="rating"
          starHoverColor={ratingData.starColor}
        />

        <div className="my-3 d-block">
          <textarea
            rows={3}
            style={{ width: "300px" }}
            placeholder="Type your comment"
          />
        </div>

        <Button
          className="trivia-action-button-main mt-5"
          style={{ width: "300px" }}
        >
          Submit
        </Button>
      </div>

      <Button
        color="primary"
        size="sm"
        onClick={() => {}}
        style={{
          width: "100px",
          position: "absolute",

          left: "70%",
          top: "90%",
        }}
      >
        Skip
      </Button>

      </div>

      <div className="d-block trivvy-comments-w-container">
        <div
          className="cursor-pointer d-flex align-items-center"
          style={{
            float: "right",
          }}
          onClick={() => setCommentsPopoverOpen(!commentsPopoverOpen)}
        >
          <span
            className="font-styling-right-sidebar-items mr-2"
            id={`comments-popover-x`}
          >
            {" "}
            Comments (
            {renderCommentsCountTextFormat(ratingData.commentsCount) || 0})
          </span>
          <FaRegComment />
        </div>

        {commentsPopoverOpen && (
          <TriviaCommentsComponent
            commentsPopoverOpen={commentsPopoverOpen}
            setCommentsPopoverOpen={setCommentsPopoverOpen}
            target={`comments-popover-x`}
            comments={ratingComments}
            setComments={setComments}
            questionId={"RATING"}
            triviaId={triviaId}
          />
        )}
      </div>
    </div>
  );
}
